import React__default from 'react';
import { makeStyles, Box, Container, Typography, TableContainer, Table as Table$1, TableHead, TableRow, TableCell, TableBody } from '@material-ui/core';
import PropTypes__default from 'prop-types';

var useGreenStyles = makeStyles(function (theme) {
  return {
    tableBox: {
      padding: theme.spacing(4, 0)
    },
    textBox: {
      textAlign: "center",
      maxWidth: theme.spacing(56)
    },
    title: {
      marginBottom: theme.spacing(1)
    },
    subtitle: {
      display: "block",
      marginBottom: theme.spacing(5)
    },
    tableContainer: {
      borderRadius: theme.spacing(1),
      maxWidth: theme.spacing(120),
      display: "flex",
      margin: theme.spacing(0, "auto")
    },
    tr: {
      position: "relative",
      "& td, th": {
        borderBottom: "none",
        textAlign: "center",
        display: "table-cell",
        width: function width(rows) {
          return "".concat(100 / rows[0].length, "%");
        }
      },
      "& th": {
        backgroundColor: theme.palette.primary[200],
        "&:first-child": {
          backgroundColor: theme.palette.primary[100],
          textAlign: "left"
        }
      },
      "& td": {
        backgroundColor: theme.palette.primary[50],
        position: "relative",
        "&::before": {
          content: "''",
          position: "absolute",
          bottom: 0,
          right: 0,
          left: 0,
          top: 0
        },
        "&:first-child": {
          backgroundColor: theme.palette.primary[100]
        },
        "&:not(:first-child):not(:last-child)": {
          "&::before": {
            borderRight: "1px solid ".concat(theme.palette.primary[100])
          }
        }
      },
      "&:last-child td": {
        "&::before": {
          height: "80%"
        }
      },
      "&:not(:last-child) td": {
        position: "relative",
        "&::before": {
          borderBottom: "1px solid ".concat(theme.palette.primary[100])
        },
        "&:first-child": {
          "&::before": {
            borderBottom: "1px solid ".concat(theme.palette.primary[200]),
            margin: theme.spacing(0, "auto"),
            width: "90%"
          }
        },
        "&:nth-of-type(2)": {
          "&::before": {
            marginLeft: "auto",
            width: "90%"
          }
        },
        "&:last-child": {
          "&::before": {
            marginRight: "auto",
            width: "90%"
          }
        }
      }
    }
  };
});
var useWhiteStyles = makeStyles(function (theme) {
  return {
    tableBox: {
      marginBottom: theme.spacing(5)
    },
    tableContainer: {
      maxWidth: theme.spacing(70),
      display: "flex",
      margin: theme.spacing(0, "auto")
    },
    tableBody: {
      "& tr:last-child": {
        borderTop: "1px solid #585855"
      }
    },
    tr: {
      position: "relative",
      "& td, th": {
        borderBottom: "none"
      },
      "& th:first-child, td:first-child": {
        textAlign: "left"
      },
      "& th, &:not(:last-child) td": {
        padding: theme.spacing(1, 2)
      }
    }
  };
});
var useStyles = makeStyles(function (theme) {
  return {
    textBox: {
      textAlign: "center",
      maxWidth: theme.spacing(56)
    },
    title: {
      marginBottom: theme.spacing(1)
    },
    subtitle: {
      display: "block",
      marginBottom: theme.spacing(5)
    }
  };
});
var Table = function Table(_ref) {
  var bgColor = _ref.bgColor,
    title = _ref.title,
    subtitle = _ref.subtitle,
    rows = _ref.rows,
    variation = _ref.variation;
  var classes,
    thVariant = "h6",
    getTdVariant = function getTdVariant() {
      return "h6";
    };
  if (variation === "green") {
    classes = useGreenStyles(rows);
  } else if (variation === "white") {
    classes = useWhiteStyles();
    thVariant = "body1";
    getTdVariant = function getTdVariant(index) {
      return rows && index === rows.length - 1 ? "h6" : "body1";
    };
  } else {
    classes = useStyles();
  }
  return /*#__PURE__*/React__default.createElement(Box, {
    className: classes.tableBox,
    bgcolor: bgColor
  }, /*#__PURE__*/React__default.createElement(Container, null, /*#__PURE__*/React__default.createElement(Box, {
    className: classes.textBox,
    display: "flex",
    flexDirection: "column",
    mx: "auto"
  }, /*#__PURE__*/React__default.createElement(Typography, {
    className: classes.title,
    variant: "h6",
    component: "h2"
  }, title), /*#__PURE__*/React__default.createElement(Typography, {
    className: classes.subtitle,
    variant: "body2"
  }, subtitle)), rows && /*#__PURE__*/React__default.createElement(TableContainer, {
    className: classes.tableContainer
  }, /*#__PURE__*/React__default.createElement(Table$1, null, /*#__PURE__*/React__default.createElement(TableHead, null, /*#__PURE__*/React__default.createElement(TableRow, {
    className: classes.tr
  }, rows[0].map(function (row, index) {
    return /*#__PURE__*/React__default.createElement(TableCell, {
      key: index
    }, /*#__PURE__*/React__default.createElement(Typography, {
      variant: thVariant,
      component: "div"
    }, row));
  }))), /*#__PURE__*/React__default.createElement(TableBody, {
    className: classes.tableBody
  }, rows.map(function (row, index) {
    if (index === 0) {
      return false;
    }
    return /*#__PURE__*/React__default.createElement(TableRow, {
      className: classes.tr,
      key: index
    }, row.map(function (c, cellIndex) {
      return /*#__PURE__*/React__default.createElement(TableCell, {
        key: index * cellIndex
      }, /*#__PURE__*/React__default.createElement(Typography, {
        variant: getTdVariant(index),
        component: "div"
      }, c));
    }));
  }))))));
};
Table.propTypes = {
  bgColor: PropTypes__default.string,
  title: PropTypes__default.string,
  subtitle: PropTypes__default.string,
  rows: PropTypes__default.arrayOf(PropTypes__default.arrayOf(PropTypes__default.string)),
  variation: PropTypes__default.string
};

export { Table as default };
//# sourceMappingURL=Table.js.map
